let puristPhotoSwipeModulePromise;

function getPuristPhotoSwipeModule() {
  if (!window.puristThemeAssets?.photoswipe) {
    return Promise.reject(new Error('PhotoSwipe asset URL not found.'));
  }

  if (!puristPhotoSwipeModulePromise) {
    puristPhotoSwipeModulePromise = import(window.puristThemeAssets.photoswipe);
  }

  return puristPhotoSwipeModulePromise;
}

function registerPuristPhotoSwipeUi(pswp, totalItems) {
  pswp.on('uiRegister', () => {
    pswp.ui.registerElement({
      name: 'purist-close',
      order: 3,
      isButton: true,
      appendTo: 'bar',
      className: 'purist-pswp__button',
      ariaLabel: 'Close gallery',
      html: `
        <svg aria-hidden="true" viewBox="0 0 18 17" fill="none">
          <path d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z" fill="currentColor"/>
        </svg>
      `,
      onClick: () => pswp.close(),
    });

    if (totalItems > 1) {
      pswp.ui.registerElement({
        name: 'purist-prev',
        order: 1,
        isButton: true,
        appendTo: 'bar',
        className: 'purist-pswp__button pswp__button--arrow',
        ariaLabel: 'Previous image',
        html: `
          <svg aria-hidden="true" viewBox="0 0 16 18" fill="none">
            <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="1.5"/>
          </svg>
        `,
        onClick: () => pswp.prev(),
      });

      pswp.ui.registerElement({
        name: 'purist-counter',
        order: 2,
        appendTo: 'bar',
        className: 'purist-pswp__counter',
        html: `1 / ${totalItems}`,
        onInit: (el, instance) => {
          const renderCounter = () => {
            el.innerHTML = `${instance.currIndex + 1} / ${totalItems}`;
          };

          renderCounter();
          instance.on('change', renderCounter);
        },
      });

      pswp.ui.registerElement({
        name: 'purist-next',
        order: 4,
        isButton: true,
        appendTo: 'bar',
        className: 'purist-pswp__button pswp__button--arrow',
        ariaLabel: 'Next image',
        html: `
          <svg aria-hidden="true" viewBox="0 0 16 18" fill="none">
            <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square" stroke-width="1.5"/>
          </svg>
        `,
        onClick: () => pswp.next(),
      });
    }
  });
}

(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function getHeaderOffset() {
    const selectors = [
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      '.section-header',
      'sticky-header',
      '.header-wrapper',
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        return Math.round(element.getBoundingClientRect().height);
      }
    }

    return 0;
  }

  function setupProductHero(productRoot) {
    if (!productRoot || !mobileQuery.matches) return;

    const mediaWrapper = productRoot.querySelector('.product__media-wrapper--mobile-hero');
    if (!mediaWrapper) return;

    const heroHeight = Math.max(window.innerHeight || 0, 320);
    const headerOffset = getHeaderOffset();

    productRoot.style.setProperty('--mobile-pdp-gallery-height', `${heroHeight}px`);
    productRoot.style.setProperty('--mobile-pdp-gallery-offset', `${headerOffset}px`);
    mediaWrapper.classList.add('product__media-wrapper--mobile-hero-ready');
  }

  function resetProductHero(productRoot) {
    if (!productRoot) return;

    productRoot.style.removeProperty('--mobile-pdp-gallery-height');
    productRoot.style.removeProperty('--mobile-pdp-gallery-offset');
  }

  function syncProductHeroes() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach((productRoot) => {
      if (mobileQuery.matches) {
        setupProductHero(productRoot);
      } else {
        resetProductHero(productRoot);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', syncProductHeroes);
  document.addEventListener('product-info:loaded', syncProductHeroes);
  window.addEventListener('resize', syncProductHeroes);
  window.addEventListener('orientationchange', syncProductHeroes);
})();

(() => {
  const productSelector = 'product-info[id^="MainProduct-"]';

  function getPhotoSwipeModule() {
    return getPuristPhotoSwipeModule();
  }

  function getImageSlides(productRoot) {
    return Array.from(
      productRoot.querySelectorAll('.product__media-list .product__media-item[data-media-id]')
    ).filter((item) => item.querySelector('.product__modal-opener--image img'));
  }

  function getDataSource(productRoot) {
    return getImageSlides(productRoot)
      .map((item) => {
        const image = item.querySelector('.product__modal-opener--image img');
        if (!image) return null;

        const width = parseInt(image.getAttribute('width'), 10) || image.naturalWidth || 1600;
        const height = parseInt(image.getAttribute('height'), 10) || image.naturalHeight || 2000;

        return {
          src: image.currentSrc || image.src,
          srcset: image.getAttribute('srcset') || '',
          msrc: image.currentSrc || image.src,
          alt: image.getAttribute('alt') || '',
          width,
          height,
        };
      })
      .filter(Boolean);
  }

  function registerUi(pswp, totalItems) {
    registerPuristPhotoSwipeUi(pswp, totalItems);
  }

  async function openProductGallery(productRoot, clickedSlide) {
    const dataSource = getDataSource(productRoot);
    if (!dataSource.length) return;

    const imageSlides = getImageSlides(productRoot);
    const startIndex = Math.max(imageSlides.indexOf(clickedSlide), 0);
    const { default: PhotoSwipe } = await getPhotoSwipeModule();

    const pswp = new PhotoSwipe({
      dataSource,
      index: startIndex,
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: dataSource.length > 1,
      arrowKeys: true,
      closeOnVerticalDrag: true,
      pinchToClose: true,
      secondaryZoomLevel: 2.5,
      maxZoomLevel: 4,
      spacing: 0.1,
      arrowPrev: false,
      arrowNext: false,
      close: false,
      counter: false,
      zoom: false,
    });

    registerUi(pswp, dataSource.length);
    pswp.init();
  }

  function bindProductGallery(productRoot) {
    if (!productRoot || productRoot.dataset.pswpBound === 'true') return;

    productRoot.dataset.pswpBound = 'true';
    const imageToggles = productRoot.querySelectorAll(
      '.product__media-item .product__modal-opener--image .product__media-toggle'
    );

    imageToggles.forEach((toggle) => {
      if (toggle.dataset.pswpBound === 'true') return;
      toggle.dataset.pswpBound = 'true';

      toggle.addEventListener(
        'click',
        async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const clickedSlide = toggle.closest('.product__media-item');
          if (!clickedSlide) return;

          try {
            await openProductGallery(productRoot, clickedSlide);
          } catch (error) {
            console.error('Failed to open PhotoSwipe gallery', error);
          }
        },
        true
      );
    });
  }

  function initProductGalleries() {
    document.querySelectorAll(productSelector).forEach(bindProductGallery);
  }

  document.addEventListener('DOMContentLoaded', initProductGalleries);
  document.addEventListener('product-info:loaded', initProductGalleries);
})();

(() => {
  function createCardMediaImage(media, className, sizes) {
    const image = document.createElement('img');
    image.className = className;
    image.src = media.src;
    image.alt = media.alt || '';
    image.width = media.width || 1200;
    image.height = media.height || 1500;
    image.loading = 'lazy';

    if (sizes) {
      image.sizes = sizes;
    }

    return image;
  }

  function updateCardLinks(card, input) {
    const links = card.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return;

    if (input.hasAttribute('data-product-url')) {
      const productUrl = input.getAttribute('data-product-url');
      links.forEach((link) => {
        link.href = productUrl;
      });
      return;
    }

    if (!input.hasAttribute('data-variant-id')) return;

    links.forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', input.getAttribute('data-variant-id'));
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  }

  async function animateCardMediaSwap(card, input) {
    const primaryMediaElement = card.querySelector('.product-card__image--primary');
    if (!primaryMediaElement || !input.hasAttribute('data-variant-media')) return;

    const mediaContainer = primaryMediaElement.closest('.product-card__media');
    if (!mediaContainer) return;

    const nextPrimaryMedia = createCardMediaImage(
      JSON.parse(input.getAttribute('data-variant-media')),
      primaryMediaElement.className,
      primaryMediaElement.sizes
    );

    const secondaryMediaElement = card.querySelector('.product-card__image--secondary');
    if (secondaryMediaElement && input.hasAttribute('data-variant-secondary-media')) {
      const nextSecondaryMedia = createCardMediaImage(
        JSON.parse(input.getAttribute('data-variant-secondary-media')),
        secondaryMediaElement.className,
        secondaryMediaElement.sizes
      );
      secondaryMediaElement.replaceWith(nextSecondaryMedia);
    }

    if (primaryMediaElement.src === nextPrimaryMedia.src) return;

    card.classList.add('product-card--variant-switching');

    nextPrimaryMedia.style.position = 'absolute';
    nextPrimaryMedia.style.inset = '0';
    nextPrimaryMedia.style.transform = 'translate3d(12%, 0, 0)';
    nextPrimaryMedia.style.opacity = '1';
    nextPrimaryMedia.style.pointerEvents = 'none';

    mediaContainer.appendChild(nextPrimaryMedia);

    await new Promise((resolve) => {
      if (nextPrimaryMedia.complete) {
        resolve();
      } else {
        nextPrimaryMedia.addEventListener('load', resolve, { once: true });
        nextPrimaryMedia.addEventListener('error', resolve, { once: true });
      }
    });

    const timing = { duration: 220, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' };

    const oldAnimation = primaryMediaElement.animate(
      [
        { transform: 'translate3d(0, 0, 0)' },
        { transform: 'translate3d(-12%, 0, 0)' },
      ],
      timing
    );

    const newAnimation = nextPrimaryMedia.animate(
      [
        { transform: 'translate3d(12%, 0, 0)' },
        { transform: 'translate3d(0, 0, 0)' },
      ],
      timing
    );

    await Promise.allSettled([oldAnimation.finished, newAnimation.finished]);

    nextPrimaryMedia.style.position = '';
    nextPrimaryMedia.style.inset = '';
    nextPrimaryMedia.style.transform = '';
    nextPrimaryMedia.style.opacity = '';
    nextPrimaryMedia.style.pointerEvents = '';
    primaryMediaElement.replaceWith(nextPrimaryMedia);

    window.setTimeout(() => {
      card.classList.remove('product-card--variant-switching');
    }, 700);
  }

  function bindProductCardSwatches(card) {
    if (!card || card.dataset.productCardSwatchesBound === 'true') return;
    card.dataset.productCardSwatchesBound = 'true';

    card.querySelectorAll('.card-product__swatches').forEach((swatchGroup) => {
      swatchGroup.addEventListener('pointerdown', (event) => {
        event.stopPropagation();
      });

      swatchGroup.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });

    card.addEventListener('change', async (event) => {
      const input = event.target.closest('.card-information input[type="radio"]');
      if (!input) return;

      updateCardLinks(card, input);

      try {
        await animateCardMediaSwap(card, input);
      } catch (error) {
        console.error('Failed to swap product card media', error);
      }
    });
  }

  function initProductCardSwatches() {
    document.querySelectorAll('[data-product-card-swatches]').forEach(bindProductCardSwatches);
  }

  document.addEventListener('DOMContentLoaded', initProductCardSwatches);
  document.addEventListener('shopify:section:load', initProductCardSwatches);
})();

if (!customElements.get('scroll-carousel')) {
  class ScrollCarousel extends HTMLElement {
    constructor() {
      super();
      this.selectedIndex = 0;
      this.scrollEndTimer = null;
      this.isProgrammaticScroll = false;
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.addEventListener('scroll', this.onScroll, { passive: true });
      const initialIndex = this.cells.findIndex((cell) => cell.classList.contains('is-initial'));
      this.selectedIndex = Math.max(initialIndex, 0);
      this.updateAdaptiveHeight();
      if (this.cells[this.selectedIndex]) {
        this.select(this.selectedIndex, { instant: true, emitChange: true });
      }

      window.addEventListener('resize', this.updateAdaptiveHeightBound || (this.updateAdaptiveHeightBound = this.updateAdaptiveHeight.bind(this)));
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this.scrollEndTimer);
      if (this.updateAdaptiveHeightBound) {
        window.removeEventListener('resize', this.updateAdaptiveHeightBound);
      }
    }

    get cells() {
      return Array.from(this.children).filter((cell) => !cell.hasAttribute('hidden'));
    }

    get selectedCell() {
      return this.cells[this.selectedIndex] || null;
    }

    select(index, { instant = false, emitChange = true } = {}) {
      const cells = this.cells;
      if (!cells[index]) return;

      this.selectedIndex = index;
      this.isProgrammaticScroll = true;
      this.scrollTo({
        left: cells[index].offsetLeft,
        behavior: instant ? 'auto' : 'smooth',
      });
      this.updateAdaptiveHeight();

      if (emitChange) {
        this.dispatchEvent(new CustomEvent('carousel:change', { detail: { index, cell: cells[index] } }));
      }

      window.clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = window.setTimeout(() => {
        this.isProgrammaticScroll = false;
        this.dispatchEvent(new CustomEvent('carousel:settle', { detail: { index, cell: cells[index] } }));
      }, instant ? 0 : 180);
    }

    onScroll() {
      if (this.isProgrammaticScroll) return;

      const cells = this.cells;
      if (!cells.length) return;

      const scrollLeft = this.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cells.forEach((cell, index) => {
        const distance = Math.abs(cell.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== this.selectedIndex) {
        this.selectedIndex = closestIndex;
        this.dispatchEvent(
          new CustomEvent('carousel:change', { detail: { index: closestIndex, cell: cells[closestIndex] } })
        );
      }

      window.clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = window.setTimeout(() => {
        const activeCell = this.selectedCell;
        if (!activeCell) return;
        this.updateAdaptiveHeight();
        this.dispatchEvent(
          new CustomEvent('carousel:settle', { detail: { index: this.selectedIndex, cell: activeCell } })
        );
      }, 120);
    }

    updateAdaptiveHeight() {
      if (!this.hasAttribute('adaptive-height')) return;

      const activeCell = this.selectedCell;
      if (!activeCell) return;

      const image = activeCell.querySelector('img');
      const applyHeight = () => {
        const trackWidth = this.clientWidth || activeCell.clientWidth || 0;
        const viewportCap = Math.round(window.innerHeight * 0.72);
        const fallbackCap = 720;

        const naturalWidth =
          parseInt(image?.getAttribute('width'), 10) || image?.naturalWidth || activeCell.clientWidth || 1;
        const naturalHeight =
          parseInt(image?.getAttribute('height'), 10) || image?.naturalHeight || activeCell.clientHeight || 1;

        const aspectRatio = naturalWidth > 0 && naturalHeight > 0 ? naturalWidth / naturalHeight : 1;
        const ratioHeight = trackWidth > 0 ? Math.round(trackWidth / aspectRatio) : 0;
        const renderedHeight = Math.round(image?.clientHeight || activeCell.clientHeight || 0);

        const nextHeight = Math.max(
          280,
          Math.min(
            renderedHeight || ratioHeight || viewportCap,
            viewportCap,
            fallbackCap
          )
        );

        this.style.maxHeight = `${nextHeight}px`;
      };

      if (image && !image.complete) {
        image.addEventListener('load', applyHeight, { once: true });
      }

      applyHeight();
    }
  }

  customElements.define('scroll-carousel', ScrollCarousel);
}

if (!customElements.get('product-gallery-navigation')) {
  class ProductGalleryNavigation extends HTMLElement {
    connectedCallback() {
      this.carousel = document.getElementById(this.getAttribute('aria-controls'));
      if (!this.carousel) return;

      this.items = Array.from(this.querySelectorAll('[data-media-id]'));
      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.carousel.select(index));
      });

      this.carousel.addEventListener('carousel:change', (event) => {
        const selectedId = event.detail.cell?.dataset.mediaId;
        this.items.forEach((item) => {
          item.setAttribute('aria-current', item.dataset.mediaId === selectedId ? 'true' : 'false');
        });

        const activeItem = this.items.find((item) => item.dataset.mediaId === selectedId);
        activeItem?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  customElements.define('product-gallery-navigation', ProductGalleryNavigation);
}

if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('scroll-carousel');
      this.sectionId = this.dataset.sectionId;
      this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));

      if (this.carousel) {
        this.addEventListener('click', this.onClick.bind(this));
      }
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber?.();
    }

    get imageCells() {
      return this.carousel?.cells?.filter((cell) => cell.dataset.mediaType === 'image') || [];
    }

    findMatchingMediaIndex(event) {
      if (!this.carousel) return -1;

      const activeMediaFromHtml = event?.data?.html?.querySelector('media-gallery .product__media-item.is-active');
      const activeMediaIdFromHtml = activeMediaFromHtml?.dataset.mediaId?.split('-').pop();
      if (activeMediaIdFromHtml) {
        const activeIndex = this.carousel.cells.findIndex(
          (cell) => String(cell.dataset.mediaId) === String(activeMediaIdFromHtml)
        );
        if (activeIndex >= 0) return activeIndex;
      }

      const featuredMediaId =
        event?.data?.variant?.featured_media?.id ||
        event?.data?.variant?.featured_image?.id ||
        event?.data?.variant?.image_id;
      if (featuredMediaId) {
        const featuredIndex = this.carousel.cells.findIndex(
          (cell) => String(cell.dataset.mediaId) === String(featuredMediaId)
        );
        if (featuredIndex >= 0) return featuredIndex;
      }

      const activeImage = activeMediaFromHtml?.querySelector('img');
      const activeImageSrc = activeImage?.currentSrc || activeImage?.getAttribute('src');
      if (activeImageSrc) {
        const normalizedSrc = activeImageSrc.split('?')[0];
        const srcIndex = this.carousel.cells.findIndex((cell) => {
          const image = cell.querySelector('img');
          const cellSrc = image?.currentSrc || image?.getAttribute('src') || '';
          return cellSrc.split('?')[0] === normalizedSrc;
        });
        if (srcIndex >= 0) return srcIndex;
      }

      return -1;
    }

    onVariantChange(event) {
      if (!event?.data || String(event.data.sectionId) !== String(this.sectionId)) return;

      const targetIndex = this.findMatchingMediaIndex(event);

      if (targetIndex >= 0) {
        this.carousel.select(targetIndex, { instant: true });
      }
    }

    async onClick(event) {
      if (event.target.tagName !== 'IMG') return;

      const mediaCell = event.target.closest('.product-gallery__media');
      if (!mediaCell || mediaCell.dataset.mediaType !== 'image') return;

      const imageIndex = this.imageCells.indexOf(mediaCell);
      if (imageIndex < 0) return;

      try {
        const dataSource = this.imageCells.map((cell) => {
          const image = cell.querySelector('img');
          return {
            src: image.currentSrc || image.src,
            srcset: image.getAttribute('srcset') || '',
            msrc: image.currentSrc || image.src,
            alt: image.getAttribute('alt') || '',
            width: parseInt(image.getAttribute('width'), 10) || image.naturalWidth || 1600,
            height: parseInt(image.getAttribute('height'), 10) || image.naturalHeight || 2000,
          };
        });

        const { default: PhotoSwipe } = await getPuristPhotoSwipeModule();
        const pswp = new PhotoSwipe({
          dataSource,
          index: imageIndex,
          bgOpacity: 1,
          showHideAnimationType: 'zoom',
          loop: dataSource.length > 1,
          closeOnVerticalDrag: true,
          pinchToClose: true,
          arrowPrev: false,
          arrowNext: false,
          close: false,
          counter: false,
          zoom: false,
        });

        registerPuristPhotoSwipeUi(pswp, dataSource.length);
        pswp.init();
      } catch (error) {
        console.error('Failed to open mobile product gallery lightbox', error);
      }
    }
  }

  customElements.define('product-gallery', ProductGallery);
}
